import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  ConfigurationAction,
  ConfigurationTypes,
  ConfigurationState
} from '../types'

export const initState: ConfigurationState = {
  isFetching: false,
  data: {
    appointmentTypeSearchEnabled: false,
    defaultEstimationDropdownType: 'cpt4',
    estimatorHost: '',
    fakeEligibility: true,
    inPatientEnable: true,
    logoEnabled: true,
    outComplexEnable: true,
    outPatientEnable: true,
    physicianFieldEnabled: true,
    procedureCodeEnabled: true,
    serviceAreaFieldEnabled: true
  }
}
export const configurationReducer: Reducer<ConfigurationState> = createReducer<
  ConfigurationState,
  ConfigurationAction
>(initState, {
  [ConfigurationTypes.CONFIGURATION_REQUEST]: (state: ConfigurationState) => ({
    ...state,
    isFetching: true
    // data: { content: [], size: 0 }
  }),
  [ConfigurationTypes.CONFIGURATION_SUCCESS]: (
    state: ConfigurationState,
    action
  ) => ({
    ...state,
    isFetching: false,
    data: { ...action.payload }
  }),
  [ConfigurationTypes.CONFIGURATION_FAIL]: (state: ConfigurationState) => ({
    ...state,
    isFetching: false
  })
})

export default configurationReducer
